module.exports = __webpack_public_path__ + "static/media/img_18.fb5eee12.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/img_18.jpg
// module id = 536
// module chunks = 0